import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Icon } from './ui/Icon';
import { Logo } from './ui/Logo';

export function AppShell() {
  const [open, setOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const signOut = async () => { await logout.mutateAsync(); navigate('/login'); };
  return (
    <div className="app-shell">
      <aside className={open ? 'sidebar is-open' : 'sidebar'}>
        <button className="sidebar__close" onClick={() => setOpen(false)} aria-label="Close navigation"><Icon name="close" /></button>
        <Logo />
        <nav>
          <NavLink to="/dashboard" onClick={() => setOpen(false)}><Icon name="profiles" />Profiles</NavLink>
          <NavLink to="/settings" onClick={() => setOpen(false)}><Icon name="settings" />Settings</NavLink>
        </nav>
        <div className="sidebar__motif" aria-hidden="true"><span>☾</span><div /></div>
        <button className="sidebar__signout" onClick={signOut}><Icon name="logout" />Sign out</button>
        <small className="sidebar__tagline">Meaningful matches<br/>for a blessed tomorrow</small>
      </aside>
      {open ? <button className="sidebar-scrim" onClick={() => setOpen(false)} aria-label="Close navigation" /> : null}
      <main className="app-main">
        <button className="mobile-menu" onClick={() => setOpen(true)} aria-label="Open navigation"><Icon name="menu" /></button>
        <Outlet />
      </main>
    </div>
  );
}
